import { combineReducers } from "redux";
import reducer from "../common";

// Kept as a combineReducers so consumers continue to read `state.raLogs.list`.
// The detail page (and its `current` slice) was removed in round 2; the list
// is the only slice we still maintain.
export default combineReducers({
  list: reducer("GET_RA_LOGS", []),
});
